























































import { Vue, Component, Prop } from 'vue-property-decorator';
import { BAlert, BButton, BFormInput, BModal, BOverlay, BSpinner } from 'bootstrap-vue';
import { Form } from '@/models/Form';
import { mapGetters } from 'vuex';

@Component({
    name: 'CardContactDetails',
    components: {
        'b-overlay': BOverlay,
        'b-spinner': BSpinner,
        'b-alert': BAlert,
        'b-button': BButton,
        'b-modal': BModal,
        'b-form-input': BFormInput,
    },
    computed: {
        ...mapGetters(['loading', 'errors', 'accessCode', 'form']),
    },
})
export default class ModalContactDetails extends Vue {
    form!: Form;
    loading!: boolean;
    errors!: string[];
    accessCode!: string;
    contact: any;

    created() {
        this.reset();
    }

    reset() {
        this.$store.commit('clearErrors');
        this.contact = {
            firstName: { value: '', isValid: true, message: 'Your first name is required.' },
            lastName: { value: '', isValid: true, message: 'Your last name is required.' },
            email: { value: '', isValid: true, message: 'Your email is required.' },
        };
    }

    validate() {
        for (const key in this.contact) {
            if (!this.contact[key].value.length) {
                this.contact[key].isValid = false;
                this.$store.commit('addError', this.contact[key].message);
            } else {
                this.contact[key].isValid = true;
                this.$store.commit('removeError', this.contact[key].message);
            }
        }
    }

    async skip() {
        await this.$store.dispatch('auth', {});
        await this.continue();
    }

    async submit() {
        this.validate();

        if (!this.errors.length) {
            await this.$store.dispatch('auth', {
                contact: {
                    firstName: this.contact.firstName.value,
                    lastName: this.contact.lastName.value,
                    email: this.contact.email.value,
                },
            });
            await this.continue();
        }
    }

    async continue() {
        this.$router.replace(`/${this.form.id}/${this.accessCode}`);
        this.$store.commit('initStorage', { formId: this.form.id, accessCode: this.accessCode });
        this.$store.commit('clearErrors');
        this.$bvModal.hide('modalContactDetails');
        await this.$store.dispatch('submit');
    }
}
